import { Suspense, useState } from "react";
import { useParams, Outlet } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { getProductLibAppIAM } from "../../graphql/queries";
import wrapPromise from "../../helpers/wrapPromise";
import PermissionContext from "../../contexts/PermissionContext";
import Waiting from "../../components/Waiting";

function UserPermission() {
  const params = useParams();
  const permissionId = params.permissionId ? params.permissionId : "";
  
  const [reload, setReload] = useState<boolean>(false);
  const fetchPermissionData = () => {
    const pem: any = API.graphql(
      graphqlOperation(getProductLibAppIAM, { id: permissionId })
    );

    return {
      permission: wrapPromise(pem),
    };
  };

  const pem = fetchPermissionData();

  const ShowPermission = ({ pem }: any) => {
    const permission = pem.permission.read();
    
    return (
      <PermissionContext.Provider value={{ permission: permission }}>
        <Outlet context={[reload, setReload]} />
      </PermissionContext.Provider>
    );
  };

  return (
    <Suspense fallback={<Waiting />}>
      <ShowPermission pem={pem} />
    </Suspense>
  );
}
export default UserPermission;
